/**
 * Featured JavaScript singleton module
 */

var Featured = (function($) {

  function initFeatured() {

    setTimeout(function(){  
      var blocksNumber = $('.grid-block').length;
      var heightBlock = $('.grid-block').first().outerHeight() * 2 + 40;
      if ($(window).width() > 1024) {
        $('.featured-block').each(function(){
          if(blocksNumber >= 4) {
            $(this).css('height', heightBlock);
          } else {
            console.log('less than');
          }
          
        });
      }
      
      $('.featured-block').each(function(){
        $(this).css('background-image', 'url(' + $(this).find('.featured-block__image img').attr('src') + ')');
      });
    }, 550);

    $(window).resize(function() {
      clearTimeout(window.resizedFinished);
      window.resizedFinished = setTimeout(function(){
        if ($(window).width() > 1024) {
        location.reload();
      }
      }, 550);
  });
   
  }

  function init() {

    // return early if no corresponding module present
    if (!$('.featured-block').length) {
      return;
    }

    initFeatured();

  }

  return {
    init: init
  };

}(jQuery));

jQuery(document).ready(Featured.init);
